import { resetRouter } from '@/router/index.js'
import router from '@/router/index.js'
import { changeroute } from '@/router/routerPermission.js'

export function patchChannelRoute() {
  const routes = JSON.parse(sessionStorage.getItem('routes') || '[]')
  routes.some((item) => {
    if (item.path === '/channel' && item.component === 'Layout') {
      item._child = []
      item.component = 'apps/common/channel/index.vue'
      resetRouter()
      router.addRoutes(changeroute(routes))
      sessionStorage.setItem('routes', JSON.stringify(routes))
      return true
    }
    return false
  })
}

export function navigateMenuItem(item) {
  if (!item) return

  if (sessionStorage.getItem('is_plugin')) {
    const ol =
      JSON.parse(sessionStorage.getItem('routesOld') || 'null') ||
      JSON.parse(sessionStorage.getItem('routes') || '[]')
    resetRouter()
    router.addRoutes(changeroute(ol))
    sessionStorage.setItem('routes', JSON.stringify(ol))
  }

  if (item.path) {
    if (item.path === '/channel') {
      patchChannelRoute()
    }
    if (item.meta && item.meta.props) {
      router.push({ path: item.path, query: { props: item.meta.props } })
    } else {
      router.push({ path: item.path })
    }
    return
  }

  const children = (item.children || []).filter((c) => c.meta && c.meta.layout == 1)
  if (!children.length) return

  const first = findFirstLeaf(children[0])
  if (!first || !first.path) return

  if (first.meta && first.meta.props) {
    router.push({ path: first.path, query: { props: first.meta.props } })
  } else {
    router.push({ path: first.path })
  }
}

function findFirstLeaf(node) {
  const kids = (node.children || []).filter((c) => c.meta && c.meta.layout == 1)
  if (kids.length) return findFirstLeaf(kids[0])
  return node
}

export function filterLayoutRoutes(routes = []) {
  return routes
    .filter((r) => r.meta && r.meta.layout == 1)
    .map((r) => {
      const children = r.children ? filterLayoutRoutes(r.children) : []
      return { ...r, children }
    })
    .filter((r) => r.path || (r.children && r.children.length))
}

export function resolveMenuIndex(item) {
  if (item.path) return item.path
  return `menu-${item.meta?.router_name || item.name || 'group'}`
}

export function hasLayoutChildren(item) {
  const children = (item.children || []).filter((c) => c.meta && c.meta.layout == 1)
  return children.length > 0
}
